<p-accordion [value]="0">
  <p-accordion-panel [value]="0">
    <p-accordion-header>Filtros</p-accordion-header>
    <p-accordion-content>
      <form method="POST" class="flex-wrap md:flex md:space-x-2 space-y-6 md:space-y-0 text-xs mt-2 align-middle"
            [formGroup]="form" (ngSubmit)="onSubmit()">

        <div>
          <app-text-input [formGroup]="form" [value]="form.value?.name" [maxLength]="50"
                          [label]="'Nome'" [hideCounter]="true"
                          id="name"></app-text-input>
        </div>

        <div>
          <app-text-input [formGroup]="form" [value]="form.value?.email" [maxLength]="100"
                          [label]="'Email'" [hideCounter]="true"
                          id="email"></app-text-input>
        </div>

        <div>
          <app-select-input [id]="'type'" [formGroup]="form"
                            [options]="motives" [label]="'Motivo'" wrapperClass="mb-4"></app-select-input>
        </div>

        <div>
          <app-select-input [id]="'status'" [formGroup]="form"
                            [options]="statuses" [label]="'Estado'" wrapperClass="mb-4"></app-select-input>
        </div>

        <div>
          <app-calendar-input [formGroup]="form" [id]="'creationDate'" [maxDate]="maxDate"
                              label="Data de Envio"></app-calendar-input>
        </div>

        <div class="grow hidden md:block"></div>

        <!-- submit button -->
        <div class="flex space-x-2">
          <app-ae-button variant="plain" label="Limpar" size="sm" styleClass="text-xs"
            (buttonClick)="onClear()"></app-ae-button>
          <app-ae-button variant="primary" icon="pi pi-search" type="submit" label="Pesquisar"
            size="sm" styleClass="text-xs"></app-ae-button>
        </div>
      </form>
    </p-accordion-content>
  </p-accordion-panel>
</p-accordion>
